import { styled } from '@mui/material/styles';
import { useSettings } from '../../../hooks/useSettings/useSettings';

type AxisLogoPlacement = 'center' | 'corner';

interface AxisLogoProps {
  placement?: AxisLogoPlacement;
}

export const AxisLogo = ({ placement = 'center' }: AxisLogoProps) => {
  const {
    settings: { logo, companyName, homepage },
  } = useSettings();

  if (!logo) {
    return null;
  }

  return (
    <AxisLogoFrame
      href={homepage}
      target='_blank'
      rel='noopener noreferrer'
      placement={placement}
    >
      <AxisLogoImage src={logo} alt={companyName || 'Axis'} />
    </AxisLogoFrame>
  );
};

const AxisLogoFrame = styled('a', {
  shouldForwardProp: (prop) => prop !== 'placement',
})<{ placement: AxisLogoPlacement }>(({ theme, placement }) => ({
  display: 'block',
  width: `clamp(${theme.spacing(9.5)}, 7vw, ${theme.spacing(11.5)})`,
  height: `clamp(${theme.spacing(4.25)}, 4vw, ${theme.spacing(5.5)})`,
  overflow: 'hidden',
  textDecoration: 'none',
  ...(placement === 'corner'
    ? {
        position: 'absolute',
        top: theme.spacing(3),
        left: theme.spacing(3),
      }
    : {
        margin: `0 auto clamp(${theme.spacing(5.875)}, 5vw, ${theme.spacing(
          8,
        )})`,
      }),

  [theme.breakpoints.down('sm')]: {
    ...(placement === 'corner'
      ? {
          top: theme.spacing(2),
          left: theme.spacing(2),
        }
      : {
          marginBottom: theme.spacing(4),
        }),
  },
}));

const AxisLogoImage = styled('img')(({ theme }) => ({
  display: 'block',
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  filter: `drop-shadow(0 ${theme.spacing(15)} 0 ${theme.palette.primary.main})`,
}));
